import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";

import useCurrentUser from "../../../../../hooks/useCurrentUser";
import { DocumentSnapshot } from "../../../../../types/firebase.types";
import { brandsMediaSubCollRef } from "../../../../../utils/referencies";
import ImageItem from "./ImageItem";

const BrandGalleryContainer = () => {
  const [media, setMedia] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [random, setRandom] = useState(0);

  const { user } = useCurrentUser();

  const fetchMediaQuery = (limit = 15) =>
    brandsMediaSubCollRef(user.id as string)
      .orderBy("createdAt", "desc")
      .limit(limit);
  const loadMoreMediaQuery = (snapshot: DocumentSnapshot) => fetchMediaQuery().startAfter(snapshot);

  const prepareMediaSnapshot = (snapshot: DocumentSnapshot) => ({
    ...snapshot.data(),
    id: snapshot.id,
    ref: snapshot.ref,
    snapshot: snapshot,
  });

  const fetchImages = async () => {
    try {
      setLoading(true);
      const snapshot = await fetchMediaQuery().get();
      const result = snapshot.docs.map(prepareMediaSnapshot);
      setMedia(result);
      setLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setLoading(false);
    }
  };

  const handleLoadMoreMedia = async () => {
    if (media.length === 0) return;
    const startAfter: DocumentSnapshot = media[media.length - 1].snapshot;

    try {
      setLoading(true);
      const snapshot = await loadMoreMediaQuery(startAfter).get();
      const result = snapshot.docs.map(prepareMediaSnapshot);
      setMedia((prevState) => [...prevState, ...result]);
      setLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setLoading(false);
    }
  };

  const isLoadMoreBtnDisabled = () => loading || media.length === 0;

  useEffect(() => {
    fetchImages();
  }, [random]);

  useEffect(() => {
    const unsub = fetchMediaQuery(1).onSnapshot({
      next(snapshot) {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            setRandom(Math.random());
          }
        });
      },
    });

    return () => {
      unsub();
    };
  }, []);

  return (
    <>
      <Box display="flex" alignItems="center" py={2} m={-0.5} flexWrap="wrap">
        {media.length ? (
          media.map((entry, index) => <ImageItem entry={entry} key={index} />)
        ) : (
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ textAlign: "center", width: "100%", padding: "8px 0" }}
          >
            No images
          </Typography>
        )}
      </Box>

      <Box display="flex" justifyContent="center">
        <Button
          variant="contained"
          color="primary"
          disabled={isLoadMoreBtnDisabled()}
          onClick={handleLoadMoreMedia}
          startIcon={loading ? <CircularProgress size={14} /> : null}
        >
          Load More
        </Button>
      </Box>
    </>
  );
};

export default BrandGalleryContainer;
